var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");

import { Link } from "react-router-dom";

var SchoolOrgUsageData = require("components/appdev/wizards/SchoolOrgUsageData");
var OrgControls = require("components/appdev/wizards/OrgControls");
var SchoolOrgAccountsPage = require("components/appdev/wizards/SchoolOrgAccountsPage");

require("appdev/wizards/school_org_details_page.scss");

class SchoolOrgDetailsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { schoolOrg: null };
	}

	getRouteActiveView(props) {
		props = props || this.props;
		var params = props.match.params;
		if (!(params && params.active_view)) {
			return CONTROLS_VIEW;
		} else {
			return params.active_view;
		}
	}

	getSchoolOrg() {
		return this.state.schoolOrg;			
	}

	onViewChange(viewKey) {
		var schoolOrg = this.getSchoolOrg();

		if (viewKey == STATISTICS_VIEW) {
			$wr.redirect("/school_orgs/" + schoolOrg.id + "/details/usage");
		} else if (viewKey == CONTROLS_VIEW) {
			$wr.redirect("/school_orgs/" + schoolOrg.id + "/details/controls");
		} else if (viewKey == ACCOUNTS_VIEW) {
			$wr.redirect("/school_orgs/" + schoolOrg.id + "/details/accounts");
		}
	}

	render() {
		var schoolOrg = this.getSchoolOrg();

		if (schoolOrg == null) {
			return (
				<div className="schoolOrgDetailsPage container">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else if (!schoolOrg.primary_admin) {
			var noPrimaryAdminWarning = (
				<p className="redBold">
					This school org doesn't have a primary admin yet and may
					be hard to edit.
				</p>
			)
		}

		var headerDisplay = (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>{ schoolOrg.school ? schoolOrg.school.name : "-" }</h1>
				</header>
			</div>
		);

		var toggleOptions = [
			{ key: CONTROLS_VIEW, text: "Controls"},
			{ key: ACCOUNTS_VIEW, text: "Accounts"},
			// { key: STATISTICS_VIEW, text: "Usage Statistics"},
		];

		var displayToggleOptions = (
			<div className="hideOnPrint">
				<DisplayToggleControl options={ toggleOptions }
					onChange={ this.onViewChange }
					activeOptionKey={ this.getRouteActiveView() } />
			</div>
		);

		if (this.getRouteActiveView() == STATISTICS_VIEW) {
			var viewDisplay = (
				<SchoolOrgUsageData schoolOrg={ schoolOrg } />
			);
		} else if (this.getRouteActiveView() == CONTROLS_VIEW) {
			var viewDisplay = (
				<OrgControls schoolOrg={ schoolOrg } fetchSchoolOrgDetailsF={ this.fetchSchoolOrgDetails } />
			);
		} else if (this.getRouteActiveView() == ACCOUNTS_VIEW) {
			var viewDisplay = (
				<SchoolOrgAccountsPage schoolOrg={ schoolOrg } fetchSchoolOrgDetailsF={ this.fetchSchoolOrgDetails } />
			);
		}

		return (
			<div className="schoolOrgDetailsPage container">
				{ headerDisplay }
				{ displayToggleOptions }
				{ noPrimaryAdminWarning }
				{ viewDisplay }
			</div>
		);
	}

	fetchSchoolOrgDetails(forceUpdate = false) {
		var schoolOrgID = this.props.match.params.id;

		// reset only if it's a new school_org
		if ((this.getSchoolOrg() && (schoolOrgID != this.state.schoolOrg.id)) || forceUpdate) {
			this.setState({ schoolOrg: null });
		}
		
		if (this.state.schoolOrg == null || forceUpdate) {

			var embeds = [
				"school_org.school", "school_org.primary_admin", "school_org.student_lists", "school_org.prefs",
				"school_org.student_count_cap", "school_org.admins", "school_org.teachers", "school_org.district_org",
				"school_org.active_student_lists", "student_list.inactive", "admin.primary_student_list_ids",
				// "school_org.statistics", "student_list.statistics",
				"admin.sub_student_list_ids", "admin.account", "admin.email", "student_list.admins", "student_list.primary_admin"
			]


			function shouldAddPrimaryTeacher(teacher, sl) {
				return teacher.primary_student_list_ids && teacher.primary_student_list_ids.includes(sl.id)
			}

			function shouldAddSubTeacher(teacher, sl) {
				return teacher.sub_student_list_ids && teacher.sub_student_list_ids.includes(sl.id)
			}

			CurrentUser.api().getSchoolOrg(schoolOrgID, { embed: embeds.join(",") }, $wr.apiHandler((response) => {

				// MOUNT ADMINS ON STUDENT LISTS. INSTANCIATING STUDENT_LIST.ADMINS AND STUDENT_LIST.PRIMARY_ADMIN
				_.each(response.school_org.student_lists, (sl, i) => {
					sl.admins = []
					sl.primary_admin = null

					_.each(response.school_org.teachers, (t) => {
						if (shouldAddPrimaryTeacher(t, sl)) {
							sl.primary_admin = t
							sl.admins.push(t)
						} else if (shouldAddSubTeacher(t, sl)) {
							sl.admins.push(t)
						}
					});
				});
				
				// THIS CODE HAS A LOT OF OVERLAP WITH ONE ABOVE
				_.each(response.school_org.active_student_lists, (sl, i) => {
					if (sl.admins == undefined) {
						sl.admins = []
						sl.primary_admin = null
					}

					_.each(response.school_org.teachers, (t) => {
						if (shouldAddSubTeacher(t, sl)) {
							sl.admins.push(t)
						}
					});
				});

				this.setState({ schoolOrg: response.school_org });
			}));
		}
		
	}

	componentDidUpdate(prevProps) {
		if ($wr.didParamsChange(prevProps, this.props)) {
			this.fetchSchoolOrgDetails();
		}
	}
	componentDidMount() {
		this.fetchSchoolOrgDetails();
	}
};

SchoolOrgDetailsPage.propTypes = PageStrictPropTypes({
});

var CONTROLS_VIEW = "controls";
var STATISTICS_VIEW = "usage";
var ACCOUNTS_VIEW = "accounts";

module.exports = SchoolOrgDetailsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/SchoolOrgDetailsPage.js